module.exports = __webpack_public_path__ + "img/usflag.218f936f.png";